






import { Component, Mixins, Prop } from "vue-property-decorator";
import { HisInformationTextValue } from "../../../domain/his/HisInformationValue";

@Component({
})
export default class DiseaseMainComponent extends Mixins() {
  @Prop()
  source: HisInformationTextValue;

  get formattedValue(): boolean {
    if (this.source == null) { return false; }

    const value = this.source.data[0];
    return value === "1";
  }

  preventValueChange(event: PointerEvent): void {
    event.preventDefault();
  }
}
